import React from 'react';
import { useStore } from '../../stores';
import { useTranslateFunction } from '../../helpers/useTranslationHook';
import { joinText, findImageSource } from '../../helpers/textUtils';

export const ContactData = () => {

  const { poi } = useStore();
  const { t } = useTranslateFunction('infolayer')

  const cityAndCountryString = joinText(
    [poi.active?.address?.city, poi.active?.address?.country],
    ', ',
  );

  const imageSource = poi.active?.url
    ? t(findImageSource(poi.active?.url))
    : '';

   const checkUrlFormat = (url) => {
    if (!url.includes('http')) return `https://${url}`;
    return url;
   };
  
  return (
    <>
      { poi.active?.address?.street ? (
        <div className="relative mb-3 pl-6 text-neutral-600 text-md">
          <span className="text-neutral-400 text-lg absolute top-[-1px] left-0 icon icon-region" />
          {joinText(
              [
              poi.active.address?.street,
              poi.active.address?.number,
              poi.active.address?.zipCode,
              ],
              ' ',
          )}
          <br />
          {cityAndCountryString}
        </div>
      ) : null }

      { poi.active.phone ? (
        <div className="relative mb-3 pl-6 text-neutral-600 text-md">
          <span className="text-neutral-400 text-lg absolute top-[-1px] left-0 icon icon-telephone" />
          <a className="hover:text-black" href={'tel:' + poi.active.phone}>{poi.active.phone}</a>
        </div>
      ) : null }

      { poi.active.eMail ? (
        <div className="relative mb-3 pl-6 text-neutral-600 text-md">
          <span className="text-neutral-400 text-lg absolute top-[-1px] left-0 icon icon-mail" />
          <a className="hover:text-black" href={'mailto:' + poi.active.eMail}>{poi.active.eMail}</a>
        </div>
      ) : null }

      { poi.active.url ? (
        <div className="relative mb-3 pl-6 text-neutral-600 text-md">
          <span className="text-neutral-400 text-lg absolute top-[-1px] left-0 icon icon-onlinecheckin" />
          <a className="hover:text-black" href={checkUrlFormat(poi.active.url)} target="_blank" rel="noreferrer">
              {imageSource}
          </a>
        </div>
      ) : null }
    </>
  );
 
};